import { Component, OnInit, Input, NgZone, OnDestroy } from '@angular/core';
import { FirebaseRepositoryService } from '../../firebase-repository.service';
import { Router, ActivatedRoute} from '@angular/router';
import { NbToastrService, NbDialogService } from '@nebular/theme';
import { ComunidadService } from '../../comunidad.service';
import { NbDialogRef } from '@nebular/theme';
import { Optional } from '@angular/core';
import { TipoEntidadService, TipoEntidad } from '../../services/tipo-entidad.service';
import { AuthFirebaseService } from '../../auth-firebase.service';
import { TermsService } from '../../services/terms.service';
import { TermsModalComponent } from './terms-modal.component';
import * as firebase from 'firebase/compat/app';
import { TipoAccesoService } from '../../services/tipo-acceso.service';

interface Comunidad {
  identifier: string;
  name: string;
}

@Component({
  selector: 'ngx-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})

export class RegisterComponent implements OnInit, OnDestroy {

  @Input() entidad: any;
  @Input() titulo: string = "Nueva Entidad";

  loading = false;
  acceptedTerms = false;

  comunidades: Comunidad[] = [];

  cifTouched = false;

  tiposEntidadJson: TipoEntidad[] = [];
  typeSize: TipoEntidad[] = [];

  isUserAuthenticated = false;
  isEmailVerified = false;
  currentUserEmail: string | null = null;
  emailVerificationCheckInterval: any;
  tipoRegistro: string = 'ENTITY';
  entidad_label: string = "entidad";

  titularRegistrado = false;

  constructor(
    private repoService: FirebaseRepositoryService,
    private router: Router,
    private route: ActivatedRoute,
    private toastrService: NbToastrService,
    private comunidadService: ComunidadService,
    private tipoEntidadService: TipoEntidadService,
    private authService: AuthFirebaseService,
    private dialogService: NbDialogService,
    private termsService: TermsService,
    private ngZone: NgZone,
    private tipoAcceso: TipoAccesoService,
  ) {}

  ngOnInit(): void {

    // Verificar autenticacion y verificacion de email
    this.checkAuthenticationStatus();

    // Inicializar el formulario de FirebaseUI si el usuario no está autenticado
    if (!this.isUserAuthenticated) {
      this.initializeAuthUI();
    }

    if(this.tipoAcceso.isCompanyEnvironment()) {
      console.log('Tipo de registro de empresa')
      this.tipoRegistro = 'COMPANY';
      this.entidad_label = "empresa";
      this.titulo = "Nueva Empresa";
    }else{
      console.log('Tipo de registro de entidad')
    }
    this.comunidadService.getComunidades().subscribe(data => {
      this.comunidades = data;
    });

    if (!this.entidad) {
      this.entidad = {
        name: '',
        type: this.tipoRegistro,
        size: '',
        email: '',
        postalAddress: '',
        postalCode: '',
        city: '',
        province: '',
        codCA: '',
        cif: '',
      };
    }


    this.tipoEntidadService.getTipos().subscribe(data => {
    this.tiposEntidadJson = data;
    this.actualizarTipos();
    });

    this.route.queryParams.subscribe(params => {
      const email = params['email'];
      this.entidad.email = email;
    });

  }

  checkAuthenticationStatus(): void {
    const currentUser = firebase.default.auth()?.currentUser;



    if (currentUser) {
      this.repoService.getUserById(currentUser.uid).subscribe(datos => {
        if(datos && datos.id == currentUser.uid) this.titularRegistrado = true;
      });
      this.isUserAuthenticated = true;
      this.currentUserEmail = currentUser.email;
      this.isEmailVerified = currentUser.emailVerified;

      // Pre-rellenar el email del formulario con el email del usuario autenticado
      if (!this.entidad || !this.entidad.email) {
        if (!this.entidad) {
          this.entidad = {};
        }
        this.entidad.email = currentUser.email;
      }
    } else {
      this.isUserAuthenticated = false;
      this.isEmailVerified = false;
      this.currentUserEmail = null;
    }
  }

  initializeAuthUI(): void {
    // Inicializar el formulario de FirebaseUI
    this.authService.initAuthUi('#register-firebaseui-auth-container').subscribe(() => {
      // Cuando el usuario se autentica, verificar el estado
      this.checkAuthenticationStatus();
      // Si el usuario está autenticado pero sin verificar, iniciar verificación periódica
      if (this.isUserAuthenticated && !this.isEmailVerified) {
        this.startEmailVerificationCheck();
      }
    });
  }

  startEmailVerificationCheck(): void {
    // Verificar cada 3 segundos si el usuario ha verificado su email
    this.emailVerificationCheckInterval = setInterval(() => {
      const currentUser = firebase.default.auth()?.currentUser;
      if (currentUser) {
        // Recargar el usuario para obtener el estado más reciente
        currentUser.reload().then(() => {
          this.isEmailVerified = currentUser.emailVerified;
          // Si el email se ha verificado, detener el intervalo
          if (this.isEmailVerified) {
            this.stopEmailVerificationCheck();
          }
        });
      }
    }, 3000);
  }

  stopEmailVerificationCheck(): void {
    if (this.emailVerificationCheckInterval) {
      clearInterval(this.emailVerificationCheckInterval);
      this.emailVerificationCheckInterval = null;
    }
  }

  onUserAuthenticated(): void {
    // Callback cuando el usuario se autentica desde LoginComponent
    this.checkAuthenticationStatus();

    // Inicializar el formulario de la entidad con el email del usuario
    if (this.currentUserEmail && !this.entidad.email) {
      this.entidad.email = this.currentUserEmail;
    }

    // Si el usuario está autenticado pero sin verificar, iniciar verificación periódica
    if (this.isUserAuthenticated && !this.isEmailVerified) {
      this.startEmailVerificationCheck();
    }
  }

  ngOnDestroy(): void {
    // Limpiar el intervalo cuando se destruye el componente
    this.stopEmailVerificationCheck();
  }

  actualizarTipos() {

    this.typeSize = this.tiposEntidadJson.filter(x => x.type === this.tipoRegistro.toLowerCase());

    if (!this.typeSize.some(x => x.identifier === this.entidad.size)) {
        this.entidad.size = '';
    }
  }

  async saveEntidad() {
    if (
      !this.validarIdentificacion(this.entidad.cif) ||
      !/^\d{5}$/.test(this.entidad.postalCode) ||
      !this.entidad.email
    ) {
      this.toastrService.show('Revisa los datos del formulario');
      return;
    }

    if (!this.acceptedTerms) {
      this.toastrService.show('Debes aceptar las condiciones de uso');
      return;
    }

    this.loading = true;

    try {
      await this.repoService.autoRegistroEntidad(this.entidad);
      this.toastrService.show('Entidad creada correctamente');
      this.router.navigate(['pages/daashboard']);
    } catch (error) {
      console.error(error);
      this.toastrService.show('Error al guardar la entidad');
    } finally {
      this.loading = false;
    }
  }


  close() {
    this.entidad = {
      name: '',
      type: this.tipoRegistro,
      size: '',
      email: '',
      postalAddress: '',
      postalCode: '',
      city: '',
      province: '',
      codCA: '',
      cif: '',
    };
    this.router.navigate(['auth/login']);
  }

  openTermsModal(): void {
    this.termsService.getTermsAsHtml().subscribe(
      (termsHtml: string) => {
        this.dialogService.open(TermsModalComponent, {
          context: {
            termsContent: termsHtml
          },
          hasScroll: true,
          closeOnBackdropClick: false,
          closeOnEsc: false
        }).onClose.subscribe();
      },
      (error) => {
        console.error('Error loading terms:', error);
        this.toastrService.show('Error al cargar las condiciones de uso');
      }
    );
  }

  validarIdentificacion(cif: string): boolean {
    if (!cif) return false;

    cif = cif.trim().toUpperCase();

    // -----------------------------------
    // 1. VALIDAR NIF (personas físicas)
    // -----------------------------------
    const regexNIF = /^\d{8}[A-Z]$/;

    if (regexNIF.test(cif)) {
      const letrasNIF = 'TRWAGMYFPDXBNJZSQVHLCKE';
      const numero = parseInt(cif.substring(0, 8), 10);
      const letra = cif[8];

      return letra === letrasNIF[numero % 23];
    }

    // -----------------------------------
    // 2. VALIDAR NIE (extranjeros)
    // -----------------------------------
    const regexNIE = /^[XYZ]\d{7}[A-Z]$/;

    if (regexNIE.test(cif)) {
      const letrasNIF = 'TRWAGMYFPDXBNJZSQVHLCKE';

      const prefijo = cif[0] === 'X' ? '0' :
                      cif[0] === 'Y' ? '1' : '2';

      const numero = parseInt(prefijo + cif.substring(1, 8), 10);
      const letra = cif[8];

      return letra === letrasNIF[numero % 23];
    }

    // -----------------------------------
    // 3. VALIDAR CIF (personas jurídicas)
    // -----------------------------------
    const regex = /^[ABCDEFGHJNPQRSUVW]\d{7}[0-9A-J]$/;
    if (!regex.test(cif)) return false;

    const letrasControl = 'JABCDEFGHI';
    const letraInicial = cif[0];
    const numeros = cif.substring(1, 8);
    const control = cif[8];

    let sumaPares = 0;
    let sumaImpares = 0;

    for (let i = 0; i < numeros.length; i++) {
      const n = parseInt(numeros[i], 10);
      if (i % 2 === 0) {
        let mult = n * 2;
        sumaImpares += mult > 9 ? mult - 9 : mult;
      } else {
        sumaPares += n;
      }
    }

    const sumaTotal = sumaPares + sumaImpares;
    const digitoControl = (10 - (sumaTotal % 10)) % 10;
    const letraControl = letrasControl[digitoControl];

    if (/[PQRSNW]/.test(letraInicial)) {
      return control === letraControl;
    } else if (/[ABEH]/.test(letraInicial)) {
      return control === String(digitoControl);
    } else {
      return control === String(digitoControl) || control === letraControl;
    }
  }


}
